import { Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CoffeeCup } from "iconoir-react";

type DisconnectedPopupProps = {
  src?: string;
  handleRestart: () => void;
};

export default function DisconnectedPopup({ src, handleRestart }: DisconnectedPopupProps) {
  return (
    <Container>
      <Background style={{ backgroundImage: `url(${src && src})` }} />
      <Overlay>
        <CoffeeCup strokeWidth={1} width={50} height={50} />
        <Typography variant="h3" gutterBottom>
          Sorry, we took a break!
        </Typography>
        <Typography variant="body1">
          To save resources, the 3D scene was closed.
          <br /> Do you want to start again?
        </Typography>
        <CallToAction>
          <Button variant="contained" onClick={handleRestart}>
            Start
          </Button>
        </CallToAction>
      </Overlay>
    </Container>
  );
}

const Container = styled("div")({
  justifyContent: "center",
  alignItems: "center",
  gridColumnStart: 1,
  gridColumnEnd: 2,
  gridRowStart: 1,
  position: "absolute",
  gridRowEnd: 2,
  display: "grid",
  gridTemplateColumns: "1fr",
  gridTemplateRows: "1fr",
  minHeight: "100%",
  cursor: "pointer",
  left: "calc(50% - 225px)",
});

const Background = styled("div")({
  opacity: 0.3,
  gridColumnStart: 1,
  gridColumnEnd: 2,
  gridRowStart: 1,
  gridRowEnd: 2,
  minHeight: "100%",
  backgroundSize: "cover",
  backgroundPosition: "center",
  cursor: "pointer",
});

const Overlay = styled("div")(({ theme }) => ({
  gridColumnStart: 1,
  gridColumnEnd: 2,
  gridRowStart: 1,
  gridRowEnd: 2,
  placeSelf: "center",
  padding: theme.spacing(4),
  display: "flex",
  width: "80%",
  maxWidth: "450px",
  flexDirection: "column",
  backgroundColor: theme.palette.grey[900],
  color: theme.palette.text.primary,
  borderRadius: theme.shape.borderRadius,
  backdropFilter: "blur(5px)",
  marginLeft: "7%",
  boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
}));

const CallToAction = styled("div")({
  marginTop: "2em",
  display: "flex",
  justifyContent: "space-between",
});
